import { Directive } from "@angular/core";
import { classes } from "@spartan-ng/helm/utils";

/**
 * O2 Sheet Footer Directive
 *
 * Fixed footer section for the sheet.
 * Typically used for action buttons (Save, Cancel, etc.).
 * Automatically styled with flexbox layout for button positioning.
 *
 * Usage:
 * <div o2SheetFooter>
 *   <button hlmBtn variant="ghost">Cancel</button>
 *   <button hlmBtn>Save</button>
 * </div>
 */
@Directive({
  selector: "[o2SheetFooter]",
  standalone: true,
})
export class O2SheetFooterDirective {
  constructor() {
    classes(() => "flex justify-end gap-[0.625rem]");
  }
}
